import BlogContainer from './BlogContainer';

export default BlogContainer;
